// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'default-passive-events'
import 'view-design/dist/styles/iview.css';
import '../src/css/global.css';

//下拉刷新、上拉加载
import { List } from 'vant';
Vue.use(List);
import { PullRefresh } from 'vant';
Vue.use(PullRefresh);


Vue.use(ViewUI);
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
Vue.component('VuePerfectScrollbar', VuePerfectScrollbar)

Vue.config.productionTip = false

import AMap from 'vue-amap';
Vue.use(AMap);
AMap.initAMapApiLoader({
  // 高德key
  key: '24d9eef764494edccbdbb72874b78243',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation'] 
  });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js